import {getAuthToken} from "@/firebase/login";
import axios from "axios";

const baseUrl = 'https://europe-west1-bork-admin-panel.cloudfunctions.net/http_http-http/companies';

export async function putCompany(company) {
    const token = await getAuthToken();
    return axios.put(baseUrl,
    // return axios.put('',
        {
            company
        },
        {
            headers: {
                'AuthToken': token
            }
        });
}

export async function getCompanies() {
    const token = await getAuthToken();
    return axios.get(baseUrl,
        {
            headers: {
                'AuthToken': token
            }
        });
}

export async function deleteCompany(docId) {
    const token = await getAuthToken();
    return axios.delete(baseUrl,
        {
            headers: {
                'AuthToken': token
            },
            data: {
                docId
            }
        });
}
